import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {interval} from 'rxjs';
import {first} from 'rxjs/operators';
import {NgClass, NgIf} from '@angular/common';
import {InfoCircleComponent} from '../svg/info-circle/info-circle.component';

@Component({
  selector: 'app-warning',
  templateUrl: './warning.component.html',
  styleUrls: ['./warning.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    InfoCircleComponent
  ]
})
export class WarningComponent implements OnInit {

  @Input()
  small = false;
  @Input()
  focus = false;

  @ViewChild('warning_message')
  warning: ElementRef;

  constructor() {
  }

  ngOnInit(): void {
    if (this.focus) {
      interval(0)
          .pipe(first())
          .subscribe(() => this.warning.nativeElement.focus());
    }
  }

}
